import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare var $;
declare var alasql;
@Component({
  selector: 'app-independente',
  templateUrl: './independente.page.html',
  styleUrls: ['./independente.page.scss'],
})
export class IndependentePage implements OnInit {

  gbCart:any=[]
  products:any;
  amplates:any;
  collapsed:any;
  colla:any;
  cats:any=[];
  total:any;
  
  constructor(public router: Router) {
    this.gbCart = [];
    this.amplates = 0;
    this.collapsed = "n";
    this.total = 0;
   }

  ngOnInit() {

    localStorage.apiurl =  "https://dash.crockstar.com/api/ws.php";
  
  }


  showcola(){
    if(this.colla == "n"){
      $("#collaone").hide();
      this.colla = "y";
    }else{
      $("#collaone").show();
      this.colla = "n";
    }
  }

  selectfilta(x){
    $( "#alllu" ).prop( "checked", false );
    for(var i = 0 ; i < this.cats.length; i++){
      console.log(this.cats[i].id_category);
      if(x != this.cats[i].id_category ){
        $( "#caty" +  this.cats[i].id_category).prop( "checked", false );
      }
    }
    
    $.getJSON( localStorage.apiurl + "?op=mealbycat&id=" + x,{},(r)=>{
      this.products = r;
    })
  }


  all(){ 
    for(var i = 0 ; i < this.cats.length; i++){ 
        $( "#caty" +  this.cats[i].id_category).prop( "checked", false ); 
    }
    
    $.getJSON(  localStorage.apiurl + "?op=get_detail_meals",{},(r)=>{
      this.products = r;
    })
  }
  
  remin(){ 
    if(this.collapsed == "n"){
      $("#cola").hide();
      this.collapsed = "y";
    }else{
      $("#cola").show();
      this.collapsed = "n";
    }
  }

    addonzero(plate) {
  
        this.gbCart.push({
          id_meals: plate.id_meals,
          name: plate.name,
          image: plate.image,
          description: plate.description,
          price: plate.price,
          qty: 1,
      })
      

      this.ampla();

      //$scope.doRefresh();
  }

  remove(ix){
    var gbtemp = []
    for (var i = 0; i < this.gbCart.length; i++) {
        if (i != ix) {
            gbtemp.push({
              id_meals: this.gbCart[i].id_meals,
              name: this.gbCart[i].name,
              image: this.gbCart[i].image,
              description: this.gbCart[i].description,
              price: this.gbCart[i].price,
              qty: this.gbCart[i].qty,
            })
        }
        if (i == (this.gbCart.length - 1)) {
            this.gbCart = gbtemp
            this.ampla();
            console.log(this.gbCart);
        }
    }
  }

  addless(ix) {
    for (var i = 0; i < this.gbCart.length; i++) {
        if (ix == this.gbCart[i].id_meals) {
            var q = +this.gbCart[i].qty - 1;
            if (q == 0 || q < 0) {
                this.remove(i)
            } else {
              this.gbCart[i].qty = +this.gbCart[i].qty - 1;
                //localStorage.setItem("cart" + localStorage.appid + Theme_id, JSON.stringify(gbCart))
                //$scope.doRefresh();
                //$rootScope.$emit("updateCart");
                this.ampla();
                break;
            }
        }
    }
  }

  

  addmore(ix) {
   
      for (var x = 0; x < this.gbCart.length; x++) {
        if (ix == this.gbCart[x].id_meals) {
          this.gbCart[x].qty = parseInt(this.gbCart[x].qty) + 1;
            console.log(this.gbCart)
            this.ampla();
            break;
        }
    }

  }

  placeorder(){
    if(this.gbCart.length == 0){
      alert("Your cart is empty")
    }else{
      localStorage.gbcart = JSON.stringify(this.gbCart);
      this.router.navigate(['/checkout'])
    }

  }

  ionViewWillEnter(){
    $.getJSON( localStorage.apiurl + "?op=get_detail_meals",{},(r)=>{
      this.products = r;
      console.log(this.products);
    })

    $.getJSON(  localStorage.apiurl + "?op=get_the_cat",{},(r)=>{
      this.cats = r;
      //console.log(this.products);
    })
    
  }

  incart(ix){

    var res = alasql('SELECT * FROM ? WHERE id_meals = "' + ix + '"', [this.gbCart]);
    if (res.length > 0) {
        return res[0].qty;
    } else {
        return 0;
    }
  }

  ampla(){
    //var lines = 0;
    var tot = 0;
    for(var i = 0 ; i < this.gbCart.length; i++){
      tot = (parseFloat(this.gbCart[i].qty) * parseFloat(this.gbCart[i].price)) + tot;
      if ((this.gbCart.length - 1) == i) {
          
          this.total = tot
      }
    }

    if(this.gbCart.length == 0){
      this.total = 0;
    }
  }
} 
